import { ContainerModule, interfaces } from "inversify";
import { InsightsApis, insightsRTTI } from "./historicalReporting/Definitions";
import { InsightsImpl } from "./historicalReporting/InsightsImpl";

export const insightsModule = new ContainerModule((bind: interfaces.Bind) => {
    bind<InsightsApis>(insightsRTTI).to(InsightsImpl).inSingletonScope();
});
